(function () {
  'use strict';

  console.log('Vehicle Compatibility Engine Loaded');

  const CATALOG_ELEMENT_ID = 'vehicle-compatibility-catalog';

  const FALLBACK_VEHICLES = [
    ['Aprilia', 'RSV4', '/collections/aprilia-rsv4', ['RSV4'], 2008, 2025],
    ['Aprilia', 'RS660', '/collections/aprilia-rs660', ['RS660', 'RS 660'], 2020, 2026],
    ['Aprilia', 'Tuono V4', '/collections/aprilia-tuono-v4', ['Tuono V4', 'TuonoV4'], 2021, 2025],
    ['Aprilia', 'Tuono 660', '/collections/aprilia-tuono-660', ['Tuono 660', 'Tuono660'], 2021, 2026],
    ['BMW', 'S1000RR', '/collections/bmw-s1000rr', ['S1000RR', 'S 1000 RR'], 2010, null],
    ['BMW', 'S1000R', '/collections/bmw-s1000r', ['S1000R', 'S 1000 R'], 2014, null],
    ['Ducati', 'Panigale V4', '/collections/ducati-panigale-v4', ['Panigale V4', 'PanigaleV4'], 2018, null],
    ['Honda', 'CBR1000RR-R', '/collections/honda-cbr1000rrr', ['CBR1000RR-R', 'CBR1000RRR'], 2020, null],
    ['Honda', 'CBR1000RR', '/collections/honda-cbr1000rr', ['CBR1000RR'], 2012, 2019],
    ['Honda', 'CBR650R', '/collections/honda-cbr650r', ['CBR650R'], 2019, null],
    ['Honda', 'CBR500R', '/collections/honda-cbr500r', ['CBR500R'], 2013, null],
    ['Honda', 'CB650R', '/collections/honda-cb650r', ['CB650R'], 2019, null],
    ['Kawasaki', 'Ninja ZX-10R', '/collections/kawasaki-zx10r', ['Ninja ZX-10R', 'ZX-10R', 'ZX10R'], 2011, null],
    ['Kawasaki', 'Ninja ZX-6R', '/collections/kawasaki-zx6r-636', ['Ninja ZX-6R', 'ZX-6R', 'ZX6R'], 2019, 2023],
    ['Kawasaki', 'Ninja 400', '/collections/kawasaki-ninja400', ['Ninja 400', 'Ninja400'], 2017, 2025],
    ['MV Agusta', 'F3', '/collections/mv-agusta-f3', ['MV Agusta F3', 'F3', 'F3 Rosso'], 2011, 2021],
    ['Suzuki', 'GSX-R1000R', '/collections/suzuki-gsxr1000r', ['GSX-R1000R', 'GSXR1000R', 'GSX R1000R'], 2017, 2025],
    ['Suzuki', 'GSX-R1000', '/collections/suzuki-gsx-r1000', ['GSX-R1000', 'GSXR1000', 'GSX R1000'], 2009, 2016],
    ['Yamaha', 'YZF-R1', '/collections/yamaha-yzf-r1', ['YZF-R1', 'R1', 'YZFR1'], 2015, 2025],
    ['Yamaha', 'YZF-R9', '/collections/yamaha-yzf-r9', ['YZF-R9', 'R9', 'YZFR9'], 2025, null],
    ['Yamaha', 'YZF-R7', '/collections/yamaha-yzf-r7', ['YZF-R7', 'R7', 'YZFR7'], 2021, 2025],
    ['Yamaha', 'YZF-R6', '/collections/yamaha-yzf-r6', ['YZF-R6', 'R6', 'YZFR6'], 2017, 2020],
    ['Yamaha', 'YZF-R3', '/collections/yamaha-yzf-r3', ['YZF-R3', 'R3', 'YZFR3'], 2014, 2024],
    ['Yamaha', 'YZF-R15', '/collections/yamaha-yzf-r15', ['YZF-R15', 'R15', 'YZFR15'], 2017, null]
  ];

  function createFallbackCatalog() {
    return {
      version: 1,
      source: 'theme-collection-catalog-fallback',
      filterMode: 'collection',
      vehicles: FALLBACK_VEHICLES.map(function (entry) {
        const make = entry[0];
        const model = entry[1];
        const collectionUrl = entry[2];
        const aliases = entry[3];
        const yearFrom = entry[4];
        const yearTo = entry[5];

        return {
          make: make,
          model: model,
          displayName: make + ' ' + model,
          aliases: aliases,
          collectionUrl: collectionUrl,
          profiles: [
            {
              active: true,
              yearFrom: yearFrom,
              yearTo: yearTo
            }
          ]
        };
      })
    };
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\s\-_]+/g, '');
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function createFlexiblePattern(value) {
    return normalize(value)
      .split('')
      .map(escapeRegExp)
      .join('[\\s\\-_]*');
  }

  function uniqueStrings(values) {
    const seen = {};

    return (values || []).filter(function (value) {
      const key = normalize(value);

      if (!key || seen[key]) {
        return false;
      }

      seen[key] = true;
      return true;
    });
  }

  function loadVehicleCatalog() {
    const element = document.getElementById(CATALOG_ELEMENT_ID);

    if (!element) {
      return createFallbackCatalog();
    }

    try {
      const catalog = JSON.parse(element.textContent);

      if (!catalog || !Array.isArray(catalog.vehicles)) {
        console.warn('Vehicle Compatibility Engine: Invalid catalog.');
        return null;
      }

      return catalog;
    } catch (error) {
      console.warn(
        'Vehicle Compatibility Engine: Could not parse catalog.',
        error
      );
      return null;
    }
  }

  function getVehicleAliases(vehicle) {
    return uniqueStrings(
      []
        .concat(vehicle.aliases || [])
        .concat([
          vehicle.displayName,
          vehicle.model,
          [vehicle.make, vehicle.model].filter(Boolean).join(' ')
        ])
    ).sort(function (a, b) {
      return normalize(b).length - normalize(a).length;
    });
  }

  function findBikeModel(searchText, catalog) {
    const query = String(searchText || '').trim();

    if (!query || !catalog) {
      return null;
    }

    const candidates = [];

    catalog.vehicles.forEach(function (vehicle) {
      getVehicleAliases(vehicle).forEach(function (alias) {
        candidates.push({
          alias: alias,
          vehicle: vehicle
        });
      });
    });

    candidates.sort(function (a, b) {
      return normalize(b.alias).length - normalize(a.alias).length;
    });

    for (let index = 0; index < candidates.length; index += 1) {
      const candidate = candidates[index];
      const aliasPattern = createFlexiblePattern(candidate.alias);
      const expression = new RegExp(
        '(^|[^a-zA-Z0-9])(' + aliasPattern + ')(?=$|[^0-9])',
        'i'
      );
      const match = expression.exec(query);

      if (match) {
        const prefixLength = match[1].length;
        const start = match.index + prefixLength;

        return {
          vehicle: candidate.vehicle,
          alias: candidate.alias,
          matchedText: match[2],
          start: start,
          end: start + match[2].length
        };
      }
    }

    return null;
  }

  function parseYear(searchText) {
    const match = String(searchText || '').match(
      /(^|[^0-9])((?:19|20)\d{2})(?=$|[^0-9])/
    );

    return match ? Number(match[2]) : null;
  }

  function collectProfileValues(profiles, fieldName) {
    const values = [];

    (profiles || []).forEach(function (profile) {
      const fieldValue = profile[fieldName];

      if (Array.isArray(fieldValue)) {
        values.push.apply(values, fieldValue);
      } else if (fieldValue) {
        values.push(fieldValue);
      }
    });

    return uniqueStrings(values).sort(function (a, b) {
      return normalize(b).length - normalize(a).length;
    });
  }

  function findDataValue(searchText, values) {
    const query = String(searchText || '');

    for (let index = 0; index < values.length; index += 1) {
      const value = values[index];
      const expression = new RegExp(
        '(^|[^a-zA-Z0-9])(' +
          createFlexiblePattern(value) +
          ')(?=$|[^a-zA-Z0-9])',
        'i'
      );
      const match = expression.exec(query);

      if (match) {
        return {
          value: value,
          matchedText: match[2]
        };
      }
    }

    return null;
  }

  function parseCompatibilityOptions(searchText, vehicle) {
    const profiles = vehicle.profiles || [];

    return {
      year: parseYear(searchText),
      market: findDataValue(
        searchText,
        collectProfileValues(profiles, 'markets').filter(function (market) {
          return normalize(market) !== 'global';
        })
      ),
      variant: findDataValue(
        searchText,
        collectProfileValues(profiles, 'variants').filter(function (variant) {
          return normalize(variant) !== 'base';
        })
      ),
      feature: findDataValue(
        searchText,
        collectProfileValues(profiles, 'features')
      ),
      generation: findDataValue(
        searchText,
        collectProfileValues(profiles, 'generation')
      )
    };
  }

  function yearMatches(profile, year) {
    if (!year) {
      return true;
    }

    const yearFrom = Number(profile.yearFrom);
    const yearTo = profile.yearTo ? Number(profile.yearTo) : null;

    return (
      (!yearFrom || year >= yearFrom) &&
      (!yearTo || year <= yearTo)
    );
  }

  function listMatches(values, selectedValue, includeGlobal) {
    if (!selectedValue) {
      return true;
    }

    const normalizedValues = (values || []).map(normalize);
    const selected = normalize(selectedValue);

    return (
      normalizedValues.indexOf(selected) !== -1 ||
      (includeGlobal && normalizedValues.indexOf('global') !== -1)
    );
  }

  function findCompatibilityProfiles(vehicle, options) {
    return (vehicle.profiles || []).filter(function (profile) {
      return (
        profile.active !== false &&
        yearMatches(profile, options.year) &&
        listMatches(
          profile.markets,
          options.market && options.market.value,
          true
        ) &&
        listMatches(
          profile.variants,
          options.variant && options.variant.value,
          false
        ) &&
        listMatches(
          profile.features,
          options.feature && options.feature.value,
          false
        ) &&
        listMatches(
          profile.generation ? [profile.generation] : [],
          options.generation && options.generation.value,
          false
        )
      );
    });
  }

  function removeAllMatches(searchText, values) {
    const patterns = uniqueStrings(values)
      .sort(function (a, b) {
        return normalize(b).length - normalize(a).length;
      })
      .map(createFlexiblePattern);

    if (!patterns.length) {
      return searchText;
    }

    const expression = new RegExp(
      '(^|[^a-zA-Z0-9])(?:' + patterns.join('|') + ')(?=$|[^0-9])',
      'gi'
    );

    return searchText.replace(expression, function (match, prefix) {
      return prefix || '';
    });
  }

  function splitKeywords(searchText, bikeResult, options) {
    let keywords = String(searchText || '');

    keywords = removeAllMatches(
      keywords,
      getVehicleAliases(bikeResult.vehicle)
    );
    keywords = removeAllMatches(keywords, [bikeResult.vehicle.make]);

    if (options.year) {
      keywords = keywords.replace(
        new RegExp(
          '(^|[^0-9])' + escapeRegExp(String(options.year)) + '(?=$|[^0-9])',
          'g'
        ),
        '$1'
      );
    }

    ['market', 'variant', 'feature', 'generation'].forEach(function (key) {
      if (options[key]) {
        keywords = removeAllMatches(keywords, [options[key].value]);
      }
    });

    return keywords
      .replace(/^[\s\-_]+|[\s\-_]+$/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildFilterUrl(catalog, vehicle, profiles, keywords, searchContext) {
    const collectionUrl =
      vehicle.collectionUrl ||
      catalog.collectionUrl ||
      '/collections/all-products';
    const filterParam =
      catalog.filterParam ||
      'filter.p.m.custom.vehicle_compatibility';

    if (!profiles.length) {
      const noMatchToken =
        catalog.noMatchSearchToken ||
        '__vehicle_compatibility_no_match__';

      return (
        collectionUrl +
        '?q=' +
        encodeURIComponent(noMatchToken) +
        '&vehicle_no_match=1' +
        '&vehicle_query=' +
        encodeURIComponent(searchContext)
      );
    }

    const profileIds = profiles
      .map(function (profile) {
        return profile.id;
      })
      .filter(Boolean)
      .map(encodeURIComponent);

    let targetUrl = collectionUrl;

    if (catalog.filterMode === 'metafield' && profileIds.length) {
      targetUrl += '?' + filterParam + '=' + profileIds.join(',');
    }

    if (keywords) {
      targetUrl +=
        (targetUrl.indexOf('?') === -1 ? '?' : '&') +
        'q=' +
        encodeURIComponent(keywords);
    }

    return targetUrl;
  }

  function redirect(targetUrl, debugData) {
    console.log('Redirect', Object.assign({}, debugData, {
      url: targetUrl
    }));

    window.location.href = targetUrl;
  }

  function attachSearchListener() {
    const catalog = loadVehicleCatalog();
    const searchForms = document.querySelectorAll('form[action="/search"]');

    if (!searchForms.length) {
      console.warn('Vehicle Compatibility Engine: No search forms found.');
      return;
    }

    searchForms.forEach(function (form) {
      if (form.dataset.vehicleCompatibilityAttached === 'true') {
        return;
      }

      const searchInput = form.querySelector('input[type="search"]');

      if (!searchInput) {
        console.warn(
          'Vehicle Compatibility Engine: Search input not found inside form.',
          form
        );
        return;
      }

      form.dataset.vehicleCompatibilityAttached = 'true';

      form.addEventListener('submit', function (event) {
        const searchText = searchInput.value.trim();
        const bikeResult = findBikeModel(searchText, catalog);

        if (!catalog || !bikeResult) {
          console.log('Fallback Search', {
            query: searchText
          });
          return;
        }

        event.preventDefault();

        const options = parseCompatibilityOptions(
          searchText,
          bikeResult.vehicle
        );
        const profiles = findCompatibilityProfiles(
          bikeResult.vehicle,
          options
        );
        const keywords = splitKeywords(searchText, bikeResult, options);
        const targetUrl = buildFilterUrl(
          catalog,
          bikeResult.vehicle,
          profiles,
          keywords,
          searchText
        );

        console.log('Bike Found', {
          query: searchText,
          vehicle: bikeResult.vehicle.displayName,
          year: options.year,
          market: options.market && options.market.value,
          variant: options.variant && options.variant.value,
          feature: options.feature && options.feature.value,
          generation: options.generation && options.generation.value,
          keywords: keywords,
          profileCount: profiles.length
        });

        redirect(targetUrl, {
          vehicle: bikeResult.vehicle.displayName,
          keywords: keywords,
          profileCount: profiles.length
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSearchListener);
  } else {
    attachSearchListener();
  }
})();
